import { defineComponent as t, openBlock as n, createBlock as a, unref as l, mergeProps as m, withCtx as p, createElementVNode as c } from "vue";
import { RevIcon as u } from "@ds/components/Icon";
const h = /* @__PURE__ */ t({
  name: "IconTruck",
  __name: "IconTruck",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const r = o;
    return (v, e) => (n(), a(l(u), m(r, { "view-box": "0 0 24 24" }), {
      default: p(() => [...e[0] || (e[0] = [
        c("path", {
          "fill-rule": "evenodd",
          d: "M2.25 6A1.25 1.25 0 0 1 3.5 4.75h10a1.25 1.25 0 0 1 1.225 1h2.966a1.25 1.25 0 0 1 1.118.691l1.655 3.31H20.5A1.25 1.25 0 0 1 21.75 11v5a1.25 1.25 0 0 1-1.25 1.25h-.854a2.751 2.751 0 0 1-5.292 0h-3.707a2.751 2.751 0 0 1-5.293 0H3.5A1.25 1.25 0 0 1 2.25 16V6m12.5 8.919a2.751 2.751 0 0 1 4.897.832h.603v-4.5l-5.5-.001v3.669m0-5.169v-2.5h2.787l1.25 2.5H14.75m-1.5 6h-2.604a2.751 2.751 0 0 0-5.292 0H3.75v-9.5h9.5v9.5m-6.5.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m9 0a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  h as default
};
